import React from 'react';

const FallingStar = () => {
    return (
        <svg
            width="24"
            height="36"
            viewBox="0 0 24 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M13.298 14.1096L14.618 16.7496C14.798 17.1096 15.278 17.4696 15.678 17.5296L18.068 17.9296C19.598 18.1896 19.958 19.2896 18.858 20.3896L16.998 22.2496C16.688 22.5596 16.508 23.1696 16.608 23.6096L17.138 25.9196C17.558 27.7396 16.588 28.4496 14.978 27.4996L12.738 26.1696C12.328 25.9296 11.668 25.9296 11.258 26.1696L9.018 27.4996C7.408 28.4496 6.438 27.7396 6.858 25.9196L7.38803 23.6096C7.48803 23.1796 7.30801 22.5696 6.99801 22.2496L5.13803 20.3896C4.03803 19.2896 4.39801 18.1796 5.92801 17.9296L8.31802 17.5296C8.71802 17.4596 9.19802 17.1096 9.37802 16.7496L10.698 14.1096C11.408 12.6796 12.588 12.6796 13.298 14.1096Z"
                stroke="#292D32"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6 15V8"
                stroke="#292D32"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M18 15V8"
                stroke="#292D32"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12 10V8"
                stroke="#292D32"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default FallingStar;
